/**
 * Absolute url of the application's home page, including the router base.
 *
 * `window.location.origin` is only right while the app is served from `/`. Behind the builder
 * proxy (`vite --mode builder`) every app lives under a path prefix (`/pms/`, `/id/`, ...), which
 * Vite exposes as `import.meta.env.BASE_URL`.
 */
export const appHomeUrl = (): string => {
  return new URL(import.meta.env.BASE_URL, window.location.origin).href
}
